























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';

@Component
export default class DeliveryInfo extends Vue {
    private eventEmit = {
        changeShippingMethod: 'changeShippingMethod'
    };

    @Prop({default: null})
    private customer: any;
    private shippingMethodProp = 1;

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    get shippingMethod() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].shippingMethod;
    }

    private async getShippingMethod() {
        const result = await commonService.getShippingMethod();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_SHIPPINGMETHOD', result.data.data);
        }
    }

    @Watch('shippingMethodProp', { immediate: true, deep: true })
    private watchShippingMethodProp() {
        this.$emit(this.eventEmit.changeShippingMethod, this.shippingMethodProp);
    }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        if (!this.shippingMethod) {
            await this.getShippingMethod();
        }
    }
}
